import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ApiService } from '../../services/api.service';
import { RouterOutlet, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LoginComponent } from '../../components/auth/login/login.component';
import { LoaderComponent } from '../../components/layout/loader/loader.component';
import { HeaderComponent } from '../header/header.component';
import { NavigationComponent } from '../navigation/navigation.component';

@Component({
  selector: 'app-base',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    LoginComponent,
    LoaderComponent,
    HeaderComponent,
    NavigationComponent
  ],
  templateUrl: './base.component.html',
  styleUrl: './base.component.scss'
})
export class BaseComponent {
  viewState: string = 'LOADING';
  loggedIn: boolean = false;

  constructor(
    private authService: AuthService,
    private apiService: ApiService,
    private router: Router
  ) {
  }

  setViewStateLoading() {
    this.viewState = 'LOADING';
  }

  setViewStateLogin() {
    this.viewState = 'LOGIN';
  }

  setViewStatePage() {
    this.viewState = 'PAGE';
  }

  isOnDashboard() {
    if (this.router.url == "/dashboard") {
      return true;
    } else {
      return false;
    }
  }

  redirectIsLoggedIn() {
    const lastRedirect = sessionStorage.getItem('lastRedirect');
    const now = Date.now();

    // Prevent redirects within a 5-second window
    if (lastRedirect && now - parseInt(lastRedirect, 10) < 5000) {
      console.warn('Preventing redirect loop due to rapid redirects.');
      return;
    }

    // Store the current timestamp to track redirects
    sessionStorage.setItem('lastRedirect', now.toString());

    // Redirect to the authentication endpoint
    const redirectUrl = `${this.authService.getIssuer()}/is-logged-in?client_id=${this.authService.getClientId()}`;
    document.location = redirectUrl;
  }

  async ngOnInit() {
    try {
      // Attempt to retrieve a valid token
      await this.authService.retrieveToken();
      this.isLoggedIn(); // Check if the user is logged in after retrieving the token
    } catch (e) {
      this.setViewStateLogin();
      this.redirectIsLoggedIn(); // Redirect if token retrieval fails
    }
  }

  signIn() {
    this.authService.login();
  }

  async isLoggedIn() {
    try {
      const response = await this.apiService.get('/me');
      this.setViewStatePage(); // User is logged in, set the appropriate state
    } catch (e) {
      this.setViewStateLogin(); // Handle case when user is not logged in
    }
  }

  signOut() {
    this.apiService.get('/logout');
    this.authService.logout();
  }
}
